import { EUROPACE_FEASIBILITY_STATUS, type EUROPACE_TYPE_FEASIBILITY_STATUS } from 'cpool-constants';
import type { SchemaEuropaceOffer } from 'cpool-schemas';
import { useTranslation } from 'react-i18next';

import { Notices } from './Notices';

type Props = {
    machbarkeitMessages?: NonNullable<SchemaEuropaceOffer['machbarkeit']>['messages'];
    vollstaendigkeitMessages?: NonNullable<SchemaEuropaceOffer['vollstaendigkeit']>['messages'];
    feasibilityStatus?: EUROPACE_TYPE_FEASIBILITY_STATUS;
};

export const OfferMessages: React.FC<Props> = ({
    feasibilityStatus,
    machbarkeitMessages,
    vollstaendigkeitMessages,
}) => {
    const { t } = useTranslation();

    const feasibilityTitle =
        feasibilityStatus === EUROPACE_FEASIBILITY_STATUS.MACHBAR_UNTER_VORBEHALT
            ? t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.FEASIBILITY_WITH_CONDITIONS')
            : t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.FEASIBILITY');

    return (
        <div className="flex flex-col gap-4 empty:hidden">
            {machbarkeitMessages && machbarkeitMessages.length > 0 && (
                <Notices
                    type={
                        feasibilityStatus === EUROPACE_FEASIBILITY_STATUS.MACHBAR_UNTER_VORBEHALT ? 'warning' : 'error'
                    }
                    messages={machbarkeitMessages}
                    title={feasibilityTitle}
                />
            )}
            {vollstaendigkeitMessages && vollstaendigkeitMessages.length > 0 && (
                <Notices
                    type="error"
                    messages={vollstaendigkeitMessages}
                    title={t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.COMPLETENESS')}
                />
            )}
        </div>
    );
};
